import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'srv-pamphlet',
  templateUrl: './srv-pamphlet.component.html',
  styleUrls: ['./srv-pamphlet.component.sass']
})
export class SrvPamphletComponent implements OnInit {
  @Input() isLightGreyBG: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
